import Axios from "axios";
import {
    SET_SALARY_OUTSTANDING_REPORT_LIST, 
    UNSET_SALARY_OUTSTANDING_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalaryOutstandingReport,
} from "@/store/api";

const state = {
    getSalaryOutstandingReport: [],
};

const getters = {
    getSalaryOutstandingReport(state) {
        return state.getSalaryOutstandingReport;
    },
};

const mutations = {
    [SET_SALARY_OUTSTANDING_REPORT_LIST](state, data) {
        state.getSalaryOutstandingReport = data;
    },
    [UNSET_SALARY_OUTSTANDING_REPORT_LIST](state) {
        state.getSalaryOutstandingReport = [];
    },
};

const actions = {

    getSalaryOutstandingReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalaryOutstandingReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_OUTSTANDING_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_OUTSTANDING_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};